import React from 'react';
import SearchBar from './SearchBar';
import SellerMap from './SellerMap';
import EnhancedSellerDirectory from './EnhancedSellerDirectory';
import SidebarAds from './SidebarAds';
import BannerAd from './BannerAd';
import PricingSection from './PricingSection';
import TestimonialsSection from './TestimonialsSection';
import InventoryTracker from './InventoryTracker';

const Homepage: React.FC = () => {

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="relative overflow-hidden bg-gradient-to-r from-slate-800 to-slate-700 text-white">
        <div className="absolute inset-0 bg-black opacity-10"></div>
        <div className="relative container mx-auto px-4 py-6 sm:py-8">
          <div className="text-center max-w-4xl mx-auto">
            <h1 className="text-lg sm:text-xl lg:text-2xl font-bold mb-3">
              Find Bees
            </h1>
            
            {/* Search Bar */}
            <div className="max-w-2xl mx-auto mb-4">
              <SearchBar placeholder="Search by location, product, or business name..." />
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <button className="bg-white text-slate-700 px-6 py-2 rounded-lg font-semibold hover:bg-slate-50 transition-colors text-base">
                Browse Map
              </button>
              <button className="border-2 border-white text-white px-6 py-2 rounded-lg font-semibold hover:bg-white hover:text-slate-700 transition-colors text-base">
                Browse Directory
              </button>
              <button className="border-2 border-white text-white px-6 py-2 rounded-lg font-semibold hover:bg-white hover:text-slate-700 transition-colors text-base">
                Sell Your Bees
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Banner Advertisement */}
      <section className="py-4 bg-gray-100">
        <div className="container mx-auto px-4">
          <BannerAd className="max-w-7xl mx-auto" />
        </div>
      </section>

      {/* Interactive Map Section with Sidebar Ads */}
      <section className="py-8 bg-white">
        <div className="container mx-auto px-4">
          <div className="flex gap-6 max-w-7xl mx-auto">
            {/* Main Map Area */}
            <div className="flex-1">
              <SellerMap className="w-full" />
            </div>
            
            {/* Sidebar with Ads */}
            <div className="w-80 flex-shrink-0">
              <SidebarAds />
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <PricingSection />

      {/* Testimonials Section */}
      <TestimonialsSection />

      {/* Live Inventory Tracker */}
      <section className="py-8 bg-white">
        <div className="container mx-auto px-4">
          <InventoryTracker className="max-w-7xl mx-auto" />
        </div>
      </section>

      {/* Seller Directory Section */}
      <section className="py-8 bg-gray-50">
        <div className="container mx-auto px-4">
          <EnhancedSellerDirectory />
        </div>
      </section>
    </div>
  );
};

export default Homepage;